import React, { useEffect } from "react";
import { Container } from "react-bootstrap";
import { useAnimations } from "../../../Logic/Animations";
import useAuthChecker from "../../../Logic/Auth/useAuthChecker";
import { useHome } from "../../../Logic/useHome";
import PlansCardStack from "../../PlansCardStack";
import Style from "./HomeChoosePlans.module.scss";
import { useSelector } from "react-redux";
import Assets from "../../Layouts/Assets";

const HomeChoosePlans = () => {
  const { slideTopRef } = useAnimations();

  const { plans, plansData, buttonCallback, isLoading } = useHome();
  const { userProfileData,status} = useSelector((state) => state.userData);
  const { isAuthCompleted } = useAuthChecker();
  useEffect(() => {
    let renew= userProfileData?.is_package?"renew":""
    if(userProfileData && status==="succeed" && isAuthCompleted){
      plans(renew);
     }
     if(!isAuthCompleted){
      plans(renew);
     }
    }, [userProfileData,isAuthCompleted]);
  return (
    <section className={Style.HomeChoosePlans}>
      <Container>
        {plansData?.length >= 1 ? (
          userProfileData.plan_payment_status === 1 ? (
            <>
              <div
                className={`section-title-block title-block-white center ${Style.heading}`}
              >
                <h2 ref={slideTopRef}>
                  <img
                    src={Assets?.tick}
                    alt="Tick"
                    className={Style.tickIcon}
                  />{" "}
                  Thank you!
                </h2>
                <p ref={slideTopRef}>
                  You activated <span>{userProfileData?.plan_name}</span>{" "}
                  plan!🎉
                </p>
              </div>
            </>
          ) : (
            <>
              <div className={`section-title-block title-block-white center `}>
                <h2 ref={slideTopRef}>Choose a Plan to Start</h2>
                <p ref={slideTopRef}>
                  You can start accessing the Photofind by using the below
                  plans.
                </p>
              </div>
            </>
          )
        ) : (
          ""
        )}
        {/* {plansData?.length !== 1 ? (
          <>
            <div className={`section-title-block title-block-white center`}>
              <h2 ref={slideTopRef}>Choose a Plan to Start</h2>
              <p ref={slideTopRef}>
                Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed
                diam nonumy eirmod tempor invidunt dolore.
              </p>
            </div>
          </>
        ) : (
          <>
            <div className={`section-title-block title-block-white center`}>
              <h2 ref={slideTopRef}>Thank you for choosing plan!</h2>
              <p ref={slideTopRef}>You already purchased a plan!</p>
            </div>
          </>
        )} */}
        <PlansCardStack
          plansData={plansData}
          buttonText={"Buy Now"}
          cardType={"main"}
          buttonCallback={buttonCallback}
          isAuthCompleted={isAuthCompleted}
          isLoading={isLoading}
        />
      </Container>
    </section>
  );
};

export default HomeChoosePlans;
